<div class="page-wrapper" [ngClass]="isMobile === true ? 'page-wrapper-mobile' : ''">
  <colimo-page-header [heading]="'sidenav.disclaimer'"> </colimo-page-header>
  <section>
    <h3 class="letter-heading">General Information</h3>
    <p>The site is operated by Surventis and all rights thereto are owned and reserved by Surventis.</p>
  </section>
  <section>
    <h3 class="letter-heading">Liability for Content</h3>
    <p>
      The content provided has been created with greatest care. For the accuracy, completeness, reliability, usability
      and timeliness of the content, Surventis cannot guarantee. The respective user is therefore generally obliged to
      professionally check or to have professionally checked the suitability of all content for its intended use.
    </p>
    <p>
      Surventis is responsible for own contents on these websites under the general laws. However, Surventis is not
      obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate
      illegal activity. Obligations to remove or block the use of information under the general laws remain unaffected.
      However, liability is only possible from the date of knowledge of a specific infringement. Upon notification of
      such violations, Surventis will remove the content immediately.
    </p>
    <p>
      This website and any product information (hereinafter" Product Information "or" Product Content")" are provided
      “as is" and to the extent permitted by law, without any kind of (express or implied) guarantee, commitment or
      liability. Except in case of willful misconduct, Surventis is not liable for damages that are caused by or in
      connection with the use of this information. In any case, Surventis is not responsible for and assumes no
      liability for any indirect, incidental or consequential damages that are caused by or in connection with the
      use of such content.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Liability for Links</h3>
    <p>
      The contents on this website also contain links to external websites on which Surventis has no control.
      Therefore Surventis cannot accept any responsibility for their content. The respective provider or operator of
      these external websites is always responsible for their content. The linked websites were checked at the time of
      linking for possible violations of law. Illegal contents were not recognizable. A permanent control of the linked
      pages is unreasonable without concrete evidence of a violation. Upon notification of violations, Surventis will
      remove such links immediately. Further Surventis is not responsible for the availability of these sites
      or their contents.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Copyright law</h3>
    <p>
      The contents and works on these pages compiled by Surventis are subject to copyright law. Copying, processing,
      distribution and any kind of use outside the limits of copyright law require the written consent of Surventis.
      In case the content is not created by Surventis, the copyrights of third parties are being observed. In particular
      contents of third parties are marked as such. However, if a user becomes aware of a copyright infringement,
      Surventis asks the user for notification. Upon notification of such violations, Surventis will remove the
      content immediately.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Product information</h3>
    <h3 class="letter-heading">Information and documents from third parties</h3>
    <p>
      As far as product information provided to the user is based on the inventory data of any third parties, the date
      of the last update can be taken from the data sheet.
    </p>
    <p>
      Although Surventis made every effort to warrant the accuracy, completeness, reliability, timeliness and usefulness
      of information by third parties, Surventis disclaims to the extent permitted by law, any warranty or liability.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Surventis information and documents</h3>
    <p>
      Information on Surventis products is based on Surventis’s current knowledge and experience and complies with the
      determinations of the admission authority. However, this does not release the user to conduct own examinations and
      tests due to the number of factors that may affect processing and application of the product. Since the storage
      and use are beyond Surventis’ control and Surventis cannot foresee all relevant circumstances, Surventis excludes
      any liability for damages resulting from improper storage and use.
    </p>
    <p>
      The application of the product in such areas that are not described in this manual has not been checked
      by Surventis. This applies especially for applications that are covered by a permit or license by the admission
      authority, but are not recommended by Surventis. Surventis therefore excludes all liability for any damages
      resulting from such application.
    </p>
    <p>
      Diverse, especially local or regional environment factors can influence the effect of the product. For such
      consequences Surventis or Surventis’ distribution partners cannot accept any liability.
    </p>
    <p>
      Existing proprietary rights, laws and regulations and the stipulations of approval of the product and the
      instructions are to be observed by the user of the product. All statements and information made herein are
      subject to change without notice.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">General conditions of sale</h3>
    <p>
      Except as otherwise specifically provided in writing, Surventis' General Conditions of Sale shall not be altered
      by this website, its content, materials and information.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Changes and updates</h3>
    <p>
      Without liability whatsoever Surventis may without notice modify and/or discontinue operation of all or portions
      of this site at any time in its sole discretion, and assumes no responsibility to update the site.
    </p>
  </section>
  <section>
    <h3 class="letter-heading">Final provisions</h3>
    <p>
      Any claims or suits associated with the site or its use shall be governed and construed in accordance with the
      laws of Germany, excluding its conflicts of law principles.
    </p>
  </section>
  <p></p>
</div>
